import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

function init() {

  const config = {
    apiKey: "AIzaSyA3OvxA_Z-rOo1F6Pz_ErwnEvbfmuF6O3A",
    authDomain: "nebu.rotemharel.com",
    databaseURL: "https://wish-list-e4f47.firebaseio.com",
    projectId: "wish-list-e4f47",
    storageBucket: "wish-list-e4f47.appspot.com",
    messagingSenderId: "371263497630"
  };

  firebase.initializeApp(config);

  return firebase;
}

export default init();



// WEBPACK FOOTER //
// ./src/lib/firebase.js